import { render, staticRenderFns } from "./ProjectPhaseChip.vue?vue&type=template&id=9fd6e988"
import script from "./ProjectPhaseChip.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectPhaseChip.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports